/**
 * @example
 * const moduleSelectors = createModuleSelectors({
 *  moduleName: 'mbreport',
 *  defaultState: {
 *    isLoading: false,
 *    user: 'qweqwe',
 * })
 *
 * const { isLoadingSelector, userSelector } = moduleSelectors;
 */

type createModuleSelectorsProps<N, S> = {
  moduleName: N;
  defaultState: S;
};

const createModuleSelectors = <
  N extends string,
  S extends object,
  SS extends { [K in N]: S },
>({
  moduleName,
  defaultState,
}: createModuleSelectorsProps<N, S>) =>
  Object.keys(defaultState).reduce(
    (result, name) => ({
      ...result,
      [`${name}Selector`]: (state: SS) => state[moduleName][name],
    }),
    {} as {
      [K in keyof S as K extends string ? `${K}Selector` : never]: (
        state: SS,
      ) => SS[N][K];
    },
  );

export default createModuleSelectors;
